// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
}

/* Profile trigger */
.dropdown.user {
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  color: var(--ca-text-primary, #172033);
  text-shadow: none;
}

.dropdown.user .dropdown-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2.5rem;
  max-width: 100%;
  padding: 0.4rem 0.65rem;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-md, 0.65rem);
  background: transparent;
  color: var(--ca-text-primary, #172033) !important;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease;
}
.dropdown.user .dropdown-toggle:hover {
  color: var(--ca-primary, #0d2863) !important;
  background: var(--ca-sidebar-hover, #eef3fb);
  text-shadow: none;
}
.dropdown.user .dropdown-toggle:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}
.dropdown.user .dropdown-toggle[aria-expanded=true] {
  color: var(--ca-primary, #0d2863) !important;
  background: var(--ca-sidebar-active, #eaf0fb);
  border-color: var(--ca-border, #d8dfeb);
}
.dropdown.user .dropdown-toggle::after {
  margin-left: 0.15rem;
  color: var(--ca-text-secondary, #64748b);
  transition: color 160ms ease, transform 160ms ease;
}
.dropdown.user .dropdown-toggle[aria-expanded=true]::after {
  color: var(--ca-primary, #0d2863);
  transform: rotate(180deg);
}
.dropdown.user .dropdown-toggle img {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  margin-right: 0 !important;
  object-fit: cover;
  border: 2px solid var(--ca-border, #d8dfeb);
  border-radius: 50%;
  background: var(--ca-bg-secondary, #f2f5fa);
  transition: border-color 160ms ease;
}
.dropdown.user .dropdown-toggle:hover img, .dropdown.user .dropdown-toggle[aria-expanded=true] img {
  border-color: var(--ca-primary-light, #2850ad);
}

.text-user {
  overflow: hidden;
  max-width: 10rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: color 160ms ease;
}

.dropdown.user .dropdown-toggle:hover .text-user {
  color: var(--ca-primary, #0d2863);
}

.dropdown.user .dropdown-toggle[aria-expanded=true] .text-user {
  color: var(--color-text-on-primary, #ffffff);
}

/* Dropdown menu */
.profile-section {
  z-index: 1050;
  min-width: 11.5rem;
  margin-top: 0.45rem !important;
  padding: 0.4rem;
  overflow: hidden;
  background: var(--ca-surface, #ffffff);
  border: 1px solid var(--ca-border, #d8dfeb);
  border-radius: var(--ca-radius-md, 0.65rem);
  box-shadow: var(--ca-shadow-md, 0 0.5rem 1.5rem rgba(7, 17, 46, 0.14));
}
.profile-section .profile-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 2.5rem;
  padding: 0.6rem 0.75rem;
  border: 0;
  border-radius: var(--ca-radius-sm, 0.4rem);
  background: transparent;
  color: var(--ca-text-primary, #172033) !important;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.3;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
}
.profile-section .profile-item:hover {
  background: var(--ca-sidebar-hover, #eef3fb);
  color: var(--ca-primary, #0d2863) !important;
}
.profile-section .profile-item:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: -2px;
  background: var(--ca-sidebar-hover, #eef3fb);
  color: var(--ca-primary, #0d2863) !important;
}
.profile-section .profile-item:active {
  background: var(--ca-sidebar-active, #eaf0fb);
  color: var(--ca-primary-dark, #041b38) !important;
}

@media (max-width: 575.98px) {
  .dropdown.user .dropdown-toggle {
    gap: 0.35rem;
    padding-inline: 0.4rem;
  }
  .dropdown.user .dropdown-toggle img {
    width: 1.85rem;
    height: 1.85rem;
  }
  .text-user {
    max-width: 7rem;
  }
  .profile-section {
    min-width: 10.5rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dropdown.user .dropdown-toggle,
  .dropdown.user .dropdown-toggle::after,
  .dropdown.user .dropdown-toggle img,
  .text-user,
  .profile-section .profile-item {
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/navigation/profile/profile.component.scss"],"names":[],"mappings":"AAiCA;EACE,cAAA;EACA,YAAA;AAhCF;;AAmCA,oBAAA;AACA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,iBAAA;AAhCF;;AAmCA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,6BAAA;EACA,2CAAA;EACA,uBAAA;EACA,iDAAA;EACA,qBAAA;EACA,eAAA;EACA,kFACE;AAjCJ;AAqCE;EACE,4CAAA;EACA,4CAAA;EACA,iBAAA;AAnCJ;AAsCE;EACE,mDAAA;EACA,mBAAA;AApCJ;AAuCE;EACE,4CAAA;EACA,6CAAA;EACA,uCAAA;AArCJ;AAwCE;EACE,oBAAA;EACA,wCAAA;EACA,kDAAA;AAtCJ;AAyCE;EACE,iCAAA;EACA,yBAAA;AAvCJ;AA0CE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,2CAAA;EACA,kBAAA;EACA,2CAAA;EACA,mCAAA;AAxCJ;AA2CE;EAEE,8CAAA;AA1CJ;;AA8CA;EACE,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;AA3CF;;AAgDA;EACE,iCAAA;AA7CF;;AA+CA;EACE,4CAAA;AA5CF;;AA+CA,kBAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;EACA,2CAAA;EACA,2CAAA;EACA,sEAAA;AA5CF;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,0CAAA;EACA,uBAAA;EACA,iDAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,yDAAA;AA5CJ;AA8CI;EACE,4CAAA;EACA,4CAAA;AA5CN;AA+CI;EACE,mDAAA;EACA,oBAAA;EACA,4CAAA;EACA,4CAAA;AA7CN;AAgDI;EACE,6CAAA;EACA,iDAAA;AA9CN;;AAmDA;EACE;IACE,YAAA;IACA,sBAAA;EAhDF;EAmDA;IACE,cAAA;IACA,eAAA;EAjDF;EAoDA;IACE,eAAA;EAlDF;EAqDA;IACE,kBAAA;EAnDF;AACF;AAsDA;EACE;;;;;IAKE,gBAAA;EApDF;AACF","sourcesContent":["\r\n// .dropdown{\r\n//      &:hover {\r\n//     color: #1a1a86;\r\n//     text-shadow: 0 2px 4px rgba(2, 56, 121, 0.5);\r\n//   }\r\n// }\r\n\r\n// .dropdown-toggle::after {\r\n//   color: #147efe;\r\n// }\r\n\r\n// .text-user{\r\n//   color: #147efe;\r\n// }\r\n\r\n\r\n//   .profile-section{\r\n//    background:#1a1a86;\r\n//    border-color:#147efe\r\n\r\n  \r\n//   }\r\n\r\n//   .profile-item{\r\n//      &:hover{\r\n//     background:#00469c;\r\n//     border-color:#ffffff;\r\n//     transition: 0.4s;\r\n//    }\r\n//   }\r\n\r\n\r\n:host {\r\n  display: block;\r\n  min-width: 0;\r\n}\r\n\r\n/* Profile trigger */\r\n.dropdown.user {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  max-width: 100%;\r\n  color: var(--ca-text-primary, #172033);\r\n  text-shadow: none;\r\n}\r\n\r\n.dropdown.user .dropdown-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  min-height: 2.5rem;\r\n  max-width: 100%;\r\n  padding: 0.4rem 0.65rem;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--ca-radius-md, 0.65rem);\r\n  background: transparent;\r\n  color: var(--ca-text-primary, #172033) !important;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition:\r\n    background-color 160ms ease,\r\n    border-color 160ms ease,\r\n    color 160ms ease;\r\n\r\n  &:hover {\r\n    color: var(--ca-primary, #0d2863) !important;\r\n    background: var(--ca-sidebar-hover, #eef3fb);\r\n    text-shadow: none;\r\n  }\r\n\r\n  &:focus-visible {\r\n    outline: 2px solid var(--ca-primary-light, #2850ad);\r\n    outline-offset: 2px;\r\n  }\r\n\r\n  &[aria-expanded='true'] {\r\n    color: var(--ca-primary, #0d2863) !important;\r\n    background: var(--ca-sidebar-active, #eaf0fb);\r\n    border-color: var(--ca-border, #d8dfeb);\r\n  }\r\n\r\n  &::after {\r\n    margin-left: 0.15rem;\r\n    color: var(--ca-text-secondary, #64748b);\r\n    transition: color 160ms ease, transform 160ms ease;\r\n  }\r\n\r\n  &[aria-expanded='true']::after {\r\n    color: var(--ca-primary, #0d2863);\r\n    transform: rotate(180deg);\r\n  }\r\n\r\n  img {\r\n    flex: 0 0 auto;\r\n    width: 2rem;\r\n    height: 2rem;\r\n    margin-right: 0 !important;\r\n    object-fit: cover;\r\n    border: 2px solid var(--ca-border, #d8dfeb);\r\n    border-radius: 50%;\r\n    background: var(--ca-bg-secondary, #f2f5fa);\r\n    transition: border-color 160ms ease;\r\n  }\r\n\r\n  &:hover img,\r\n  &[aria-expanded='true'] img {\r\n    border-color: var(--ca-primary-light, #2850ad);\r\n  }\r\n}\r\n\r\n.text-user {\r\n  overflow: hidden;\r\n  max-width: 10rem;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  line-height: 1.25;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  transition: color 160ms ease;\r\n\r\n  \r\n}\r\n\r\n.dropdown.user .dropdown-toggle:hover .text-user{\r\n  color: var(--ca-primary, #0d2863);\r\n}\r\n.dropdown.user .dropdown-toggle[aria-expanded='true'] .text-user {\r\n  color: var(--color-text-on-primary, #ffffff);\r\n}\r\n\r\n/* Dropdown menu */\r\n.profile-section {\r\n  z-index: 1050;\r\n  min-width: 11.5rem;\r\n  margin-top: 0.45rem !important;\r\n  padding: 0.4rem;\r\n  overflow: hidden;\r\n  background: var(--ca-surface, #ffffff);\r\n  border: 1px solid var(--ca-border, #d8dfeb);\r\n  border-radius: var(--ca-radius-md, 0.65rem);\r\n  box-shadow: var(--ca-shadow-md, 0 0.5rem 1.5rem rgb(7 17 46 / 14%));\r\n\r\n  .profile-item {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    min-height: 2.5rem;\r\n    padding: 0.6rem 0.75rem;\r\n    border: 0;\r\n    border-radius: var(--ca-radius-sm, 0.4rem);\r\n    background: transparent;\r\n    color: var(--ca-text-primary, #172033) !important;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    line-height: 1.3;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    transition: background-color 150ms ease, color 150ms ease;\r\n\r\n    &:hover {\r\n      background: var(--ca-sidebar-hover, #eef3fb);\r\n      color: var(--ca-primary, #0d2863) !important;\r\n    }\r\n\r\n    &:focus-visible {\r\n      outline: 2px solid var(--ca-primary-light, #2850ad);\r\n      outline-offset: -2px;\r\n      background: var(--ca-sidebar-hover, #eef3fb);\r\n      color: var(--ca-primary, #0d2863) !important;\r\n    }\r\n\r\n    &:active {\r\n      background: var(--ca-sidebar-active, #eaf0fb);\r\n      color: var(--ca-primary-dark, #041b38) !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .dropdown.user .dropdown-toggle {\r\n    gap: 0.35rem;\r\n    padding-inline: 0.4rem;\r\n  }\r\n\r\n  .dropdown.user .dropdown-toggle img {\r\n    width: 1.85rem;\r\n    height: 1.85rem;\r\n  }\r\n\r\n  .text-user {\r\n    max-width: 7rem;\r\n  }\r\n\r\n  .profile-section {\r\n    min-width: 10.5rem;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .dropdown.user .dropdown-toggle,\r\n  .dropdown.user .dropdown-toggle::after,\r\n  .dropdown.user .dropdown-toggle img,\r\n  .text-user,\r\n  .profile-section .profile-item {\r\n    transition: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
